window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */


import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/widgets/dialog.js';
require('bootstrap');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    encrypted: true
});

// window.Echo.private('my-channel')
// .listen('ChangeRoom', event => {
//   console.log('ChangeRoom notice for event ' + event.event.id + ' received.');
//   console.log(event);
// });

/*
window.Echo.channel('darby-rooms')
  .listen('ChangeRoom', event => {
      console.log('ChangeRoom notice for event ' + event.event.id + ' received.');
      console.log(event);
  });
*/

/**
 * Darby Solutions Modules
 */

require('./darby_inc');
require('./darby_front');
require('./darby_back');
require('./darby_products');
require('./darby_events');
require('./checkout');
// import * as Darby from './test.js';
// require('./test.js');
// require('./rooms');
console.log('DC JavaScript Loaded');

